import * as React from 'react'
import {useState} from 'react'

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSync} from '@fortawesome/free-solid-svg-icons'

import {ButtonAsync} from '@frontrow/console/src/components/button-async'
import {Alert as BaseAlert} from '@frontrow/console/src/components/ui/alert'
import {exhaustive} from '@freckle/exhaustive'

import type {StatusT} from '..'
import {postSchoolIdpSync} from '@frontrow/console/src/helpers/api-schools'

type Props = {
  schoolId: number
}

function SyncIdpButton({schoolId}: Props): React.ReactElement {
  const [alert, setAlert] = useState<StatusT>('initial')

  const onClick = (): Promise<void> => {
    setAlert('awaiting_response')

    return postSchoolIdpSync(schoolId)
      .then(() => {
        setAlert('success')
      })
      .catch(() => {
        setAlert('failed')
      })
  }

  return (
    <div className="flex flex-col items-start gap-2 [&_button_svg]:mr-2">
      <ButtonAsync title="Sync Idp Data" onClick={onClick}>
        <FontAwesomeIcon icon={faSync} /> Sync Idp Data
      </ButtonAsync>
      <p className="text-xs text-destructive">
        Be mindful when syncing IdP data - it uses a lot of resources!
      </p>
      <Alert status={alert} />
    </div>
  )
}

type AlertProps = {
  status: StatusT
}

const Alert = ({status}: AlertProps) => {
  switch (status) {
    case 'initial':
    case 'awaiting_response':
      return null
    case 'failed':
      return <BaseAlert type="warning">Failed to enqueue job to sync IdP data.</BaseAlert>
    case 'success':
      return (
        <BaseAlert type="success">
          Syncing IdP data for this school. Please check back in 3-5 minutes.
        </BaseAlert>
      )
    default:
      return exhaustive(status)
  }
}

export {SyncIdpButton}
